/**********************************
 * tch-fill-left-height directive
 *
 * The directive allows you to specify that a particular element must take what's left as vertical space on the page.
 * This directive comes in two pieces :
 * - tchFillLeftHeightItem allows you to specify that the eight of an element must be taken into account when computing size left
 * - tchFillLeftHeight is to be placed on the element we want to resize automatcally itself. *
 */

"use strict";

angular.module("app")

	.factory("tchFillLeftHeightDataService", function () {

		var elts = [];

		return {

			// register an element for space left computation.
			registerElementForHeightCalculus: function (elt) {
				elts = [];
				elts.push(elt);
			},

			// get actual height left
			getHeightLeft: function (delta) {
				var total = 0;
				for (var i = 0; i < elts.length; i++) {
					var elt = elts[i];
					total += elt.height();
				}
				return angular.element(window).height() - total - (delta || 0);
			}
		};

	})


	.directive("tchFillLeftHeightItem", ["tchFillLeftHeightDataService", function (tchFillLeftHeightDataService) {
		return {
			restrict: "A",
			link: function (scope, elt) {
				tchFillLeftHeightDataService.registerElementForHeightCalculus(elt);
			}
		};
	}])

	.directive("tchFillLeftHeight", ["tchFillLeftHeightDataService", function (tchFillLeftHeightDataService) {
		return {
			restrict: "A",
			scope: {

				/**
                 * Optional attribute : I had some issues with browsers compatibility, this allows me
                 * to manually input some more space so I'm sure that an element won't overflow down the screen.
                 */
				delta: "=tchFillLeftHeightDelta"
			},
			link: function (scope, elt, attrs, ctrl) {

				// for the scrollbar
				elt.css("overflow-y", "auto");

				scope.$watch(function () {
					return angular.element(document).height();
				}, function (value) {
					elt.height(tchFillLeftHeightDataService.getHeightLeft(parseInt(scope.delta)));
				});

			}
		};
	}]);